import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DMSalonHistoryMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.dm.customer.history("salon"));
  };

  return (
    <MainMenuItem
      itemTitleString="配信履歴(美容室)"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DMSalonHistoryMenuItem;
